<template>
    <div class="fw-billing">
        <div class="fw-kdtype">
            <div class="fw-leibie">
                <span :class="{'lbActive':lbIndex==0}">项目</span>
                <span :class="{'lbActive':lbIndex==1}"></span>
                <span :class="{'lbActive':lbIndex==2}"></span>
                <span :class="{'lbActive':lbIndex==3}"></span>
            </div>
            <div class="fw-gwitems">
                <div class="fw-gwitems-f">
                          <span class="fw-cats" :class="{'active':index==tabIndex}" v-for="(cat,index) in list"
                                @click="getGwItems(index,cat)">
                               {{cat.catName}}
                          </span>
                </div>
                <div class="fw-gwitems-r">
                    <div class="fwgr-item" v-for="item in items">
                        <div class="fwgr-item-info">
                            <span class="mc">{{item.itemName}}</span>
                            <span class="nr">内容：{{item.fwContent}}</span>
                            <span class="jg">¥{{item.price}}</span>
                        </div>
                        <el-button size="mini" @click="toChoose(item)">选择</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="fw-btn">
            <div class="mingxi" @click="toMx">
                <div class="mingxi-text">
                    <span style="font-size: 13px">已选项目</span>
                    <span style="margin-top: 5px;font-size: 15px">{{datas.length}}</span>
                </div>
            </div>
            <div class="baocun" @click="queding">
                <span class="baocun-btn">确 定</span>
            </div>
        </div>

        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 90%;">
            <span style="font-size: 15px;margin-left: 18px">项目列表</span>
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <div class="fw-mx-nr">
                        <div class="fw-mx-items">
                            <div class="fw-mx-item" v-for="(item,index) in datas">
                                <div class="fwmxi-info">
                                    <span class="fm-name">{{item.itemName}}</span>
                                    <span class="fm-btn" @click="delData(index)">删除</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        props: {
            jbId: String,
        },
        data() {
            return {
                title: '挂号选项',
                deptId: '',
                token: '',
                active: 0,
                list: [],
                gwJb: {},
                tabIndex: 0,
                items: [],
                lbIndex: '0',

                datas: [],
                gradeId: '',
                mxShow: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.gradeId = this.jbId
            this.roomId = this.$route.params.roomId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getCatItems()
        },
        methods: {
            getGrades(gradeId) {
                this.gradeId = gradeId
                this.getCatItems()
            },
            delData(index) {
                let item = this.datas[index];
                this.datas.splice(index, 1)
                var to = parseFloat(this.total) - parseFloat(item.price);
                this.total = to.toFixed(1)
            },

            toMx() {
                if (this.datas.length > 0) {
                    this.mxShow = true
                } else {
                    this.$notify("没添加任何商品!");
                }
            },

            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                    gradeId: this.gradeId,
                }
                let res = await this.$get("/fw/getFwCatItems", data)
                this.list = res.list
                this.items = []
                if (res.list.length > 0) {
                    this.items = res.list[0].gwItems
                }
                this.gwJb = res.gwJb
            },

            async queding() {
                this.$emit('setData', this.datas);
            },

            toChoose(item) {
                let is = true;
                this.datas.forEach(it => {
                    if (it.itemId == item.id) {
                        is = false;
                        return;
                    }
                })
                if (is) {
                    let data = {
                        itemId: item.id,
                        itemName: item.itemName,
                    }
                    this.datas.push(data)
                }
            },

            getGwItems(index, cat) {
                this.tabIndex = index
                this.items = cat.gwItems
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-billing {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
    }


    .fw-kdtype {
    }

    .fw-gwitems {
        display: flex;
        flex-direction: row;
    }

    .fw-gwitems-f {
        width: 90px;
        display: flex;
        flex-direction: column;
        padding-left: 3px;
    }

    .fw-gwitems-r {
        width: 80%;
        padding: 10px 15px 15px 5px;
    }

    .fw-cats {
        font-size: 13px;
        padding: 10px;
        line-height: 20px;
        margin-bottom: 5px;
        border-left: #ffffff solid 3px;
    }

    .active {
        border-left: #ff4d51 solid 3px;
    }

    .dianzhang {
        width: 100px;
        height: 40px;
    }

    .dianzhang1 {
        width: 100px;
        height: 60px;
        background-color: #ff4d51;
        position: absolute;
        top: 0px;
        left: 6px;
    }

    .fw-leibie {
        display: flex;
        flex-direction: row;
    }

    .fw-leibie span {
        width: 25%;
        font-size: 15px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-bottom: #eeeeee solid 1px;
    }

    .lbActive {
        color: #2b94ff;
    }

    .fwgr-item {
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;
        border-bottom: #eeeeee solid 1px;
        align-items: center;
        justify-content: space-between;
    }


    .fw-btn {
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #ffffff;
    }


    .fw-mx {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-nr {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-items {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        margin-top: 5px;
    }

    .mxemp {
        font-size: 10px;
        padding: 5px 0px;
        color: #999999;
    }

    .fw-mx-item {
        display: flex;
        flex-direction: column;
        background-color: #F7F7F7;
        margin-top: 5px;
        padding: 0 8px;
        padding-bottom: 3px;
    }

    .fwmxi-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 32px;
    }

    .fm-name {
        font-size: 13px;
        width: 80%;
    }


    .fm-btn {
        font-size: 12px;
        background-color: red;
        padding: 2px 8px;
        color: #ffffff;
    }


    .fwgr-item-info {
        display: flex;
        flex-direction: column;
        padding-left: 5px;
    }

    .fwgr-item-info .mc {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
    }

    .fwgr-item-info .nr {
        font-size: 11px;
        height: 20px;
        line-height: 20px;
        color: #A8A6A6;
    }

    .fwgr-item-info .jg {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
        color: red;
    }

</style>
